"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableChip = void 0;
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@epic-ui/icons");
var clsx_1 = __importDefault(require("clsx"));
var react_merge_refs_1 = __importDefault(require("react-merge-refs"));
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            position: "relative",
        },
        selected: {
            "&:focus": {
                boxShadow: "inset 0 0 0 1px " + palette.text.primary,
                backgroundColor: styles_1.fade(palette.type === "dark"
                    ? palette.common.white
                    : palette.common.offBlack, 0.16 + palette.action.hoverOpacity),
            },
        },
        input: {
            cursor: "inherit",
            position: "absolute",
            opacity: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
    });
}, { name: "EuiSelectableChip" });
exports.SelectableChip = React.forwardRef(function SelectableChip(_a, ref) {
    var label = _a.label, onChange = _a.onChange, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, _b = _a.inputProps, _c = _b === void 0 ? {} : _b, inputClassName = _c.className, inputProps = __rest(_c, ["className"]), _d = _a.checkedIcon, checkedIcon = _d === void 0 ? React.createElement(icons_1.Check, { fontSize: "small" }) : _d, props = __rest(_a, ["label", "onChange", "checked", "className", "defaultChecked", "inputProps", "checkedIcon"]);
    var classes = useStyles();
    // Uses either `checked` or `defaultChecked` in the initial render. Then, follows updates to `checked`.
    // This is only for visual purposes and keeps the input uncontrolled.
    var _e = React.useState(typeof checked !== "undefined" ? checked : defaultChecked), isChecked = _e[0], setIsChecked = _e[1];
    React.useEffect(function () {
        if (typeof checked !== "undefined")
            setIsChecked(checked);
    }, [checked]);
    var chipRef = React.useRef(null);
    var handleKeyUp = function (event) {
        props.onKeyUp && props.onKeyUp(event);
        if (event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            if (chipRef === null || chipRef === void 0 ? void 0 : chipRef.current) {
                chipRef.current.click();
                chipRef.current.focus();
            }
        }
    };
    return (React.createElement(core_1.Chip, __assign({ className: clsx_1.default(classes.root, className, checked && classes.selected), role: "button", "aria-pressed": checked, onKeyUp: handleKeyUp, label: React.createElement(React.Fragment, null,
            label,
            React.createElement("input", __assign({ type: "checkbox", className: clsx_1.default(classes.input, inputClassName) }, inputProps, { checked: checked, defaultChecked: defaultChecked, onChange: onChange, tabIndex: -1 }))) }, props, (isChecked
        ? { icon: checkedIcon, variant: "default" }
        : { variant: "outlined" }), { clickable: true, component: "label", ref: react_merge_refs_1.default([ref || null, chipRef]) })));
});
//# sourceMappingURL=SelectableChip.js.map